export default "__VITE_ASSET__C1gRlLy1__"